var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PriceAnalyzeService from '../../api/PriceAnalyzeService';
import SalePriceAnalyzeService from '../../api/SalePriceAnalyzeService';
import DataChart from '../../components/echarts/DataChart.vue';
var PriceAnalyze = (function (_super) {
    __extends(PriceAnalyze, _super);
    function PriceAnalyze() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = PriceAnalyzeService.getInstance();
        _this.saleService = SalePriceAnalyzeService.getInstance();
        _this.filter = {};
        _this.title = '';
        return _this;
    }
    PriceAnalyze.prototype.created = function () {
        this.title = "" + this.goods_name + (this.filter.type === 1
            ? ''
            : this.filter.type === 2
                ? this.supplier_upper_name || this.business_name
                : this.type === 2
                    ? '多客户'
                    : '多供应商') + (this.type === 2 ? '销售' : '入库') + (this.filter.dimension === 1 ? '均价' : '金额') + "\u6298\u7EBF\u56FE";
        this.getDetail();
    };
    PriceAnalyze.prototype.getDetail = function () {
        var _this = this;
        this[this.type === 2 ? 'saleService' : 'service']
            .getDetail(this.filter)
            .then(function (res) {
            var DATA = res.data || {};
            var data = DATA.data || {};
            var lineSeries = [];
            if (_this.filter.type === 3) {
                data.data.map(function (item) {
                    lineSeries.push({
                        name: item.supplier_upper_name || item.business_name,
                        type: 'line',
                        data: item.data,
                    });
                });
            }
            else {
                lineSeries = [
                    {
                        type: 'line',
                        data: data.data,
                    },
                ];
            }
            _this.$nextTick(function () {
                _this.$refs.LineChart && _this.$refs.LineChart.initChart(data.dates, lineSeries);
            });
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PriceAnalyze = __decorate([
        Component({
            components: {
                DataChart: DataChart,
            },
        })
    ], PriceAnalyze);
    return PriceAnalyze;
}(Vue));
export default PriceAnalyze;
